import React from "react";

import { Field } from "formik";

import {
  Flex,
  Text,
  Divider,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Input,
  useDisclosure,
} from "@chakra-ui/react";

import PromotoriaModal from "./PromotoriaModal";
import VaraModal from "./VaraModal";
import { numeroInscricaoPGEA } from "../../../../utils/masks";
import {
  Permission,
  situacaoJuridica,
} from "../../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../../Context/AuthProvider";

const Promotoria = ({ formProps }) => {
  const {
    isOpen: isOpenPromotoria,
    onOpen: onOpenPromotoria,
    onClose: onClosePromotoria,
  } = useDisclosure();
  const {
    isOpen: isOpenVara,
    onOpen: onOpenVara,
    onClose: onCloseVara,
  } = useDisclosure();

  const { roleKeycloack } = useAuthProvider();
  return (
    <Flex
      flexDir="column"
      mt="30px"
      pl="10px"
      pr="30px"
      py="16px"
      bgColor="#FFF"
      borderRadius="8px"
    >
      <Text
        fontWeight="700"
        fontSize="14px"
        lineHeight="19.6px"
        color="#169499"
      >
        {"Promotoria e Vara da Infância".toUpperCase()}
      </Text>
      <Divider mt="10px" orientation="horizontal" />
      <Grid
        mt="15px"
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(1, 1fr)",
          lg: "repeat(3, 1fr)",
          xl: "repeat(3, 1fr)",
        }}
        gap="15px"
      >
        <GridItem colSpan={1}>
          <Field name="promotoriaId">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.promotoriaId && form.touched.promotoriaId
                }
                id="promotoriaId"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="promotoriaId"
                >
                  Promotoria*
                </FormLabel>
                <Input
                  h="42px"
                  name="promotoriaId"
                  id="promotoriaId"
                  isDisabled
                  autoComplete="off"
                  value={field.value.nome ? field.value.nome : ""}
                  title={field.value.nome ? field.value.nome : ""}
                  backgroundColor="#fff"
                  placeholder="Buscar Promotoria"
                />
                <Input
                  {...field}
                  type="hidden"
                  name="promotoriaId"
                  id="promotoriaId"
                />
                <FormErrorMessage>{form.errors.promotoriaId}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
          <Permission
            roleKeycloack={roleKeycloack}
            func={situacaoJuridica.servicoPromotoriaBuscar}
          >
            <Flex justifyContent="flex-end" mt="5px">
              <Button
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={500}
                fontSize="13px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={onOpenPromotoria}
              >
                Buscar
              </Button>
            </Flex>
          </Permission>
        </GridItem>
        <GridItem colSpan={1}>
          <Field name="varaInfanciaId">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.varaInfanciaId && form.touched.varaInfanciaId
                }
                id="varaInfanciaId"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="varaInfanciaId"
                >
                  Vara da Infância*
                </FormLabel>
                <Input
                  h="42px"
                  name="varaInfanciaId"
                  id="varaInfanciaId"
                  autoComplete="off"
                  isDisabled
                  value={field.value.nome ? field.value.nome : ""}
                  title={field.value.nome ? field.value.nome : ""}
                  backgroundColor="#fff"
                  placeholder="Buscar Vara da Infância"
                />
                <Input
                  {...field}
                  type="hidden"
                  name="varaInfanciaId"
                  id="varaInfanciaId"
                />
                <FormErrorMessage>
                  {form.errors.varaInfanciaId}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
          <Flex justifyContent="flex-end" mt="5px">
            <Button
              color="#FFF"
              backgroundColor="#169499"
              fontWeight={500}
              fontSize="13px"
              lineHeight="21.6px"
              _hover={{ bg: "#169499" }}
              onClick={onOpenVara}
            >
              Buscar
            </Button>
          </Flex>
        </GridItem>
        <GridItem colSpan={1}>
          <Field name="numeroInclusao">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.numeroInclusao && form.touched.numeroInclusao
                }
                id="numeroInclusao"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="numeroInclusao"
                >
                  Procedimento de inclusão
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="numeroInclusao"
                  id="numeroInclusao"
                  backgroundColor="#fff"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  maxLength={30}
                  onChange={(e) => {
                    form.setFieldValue(
                      "numeroInclusao",
                      numeroInscricaoPGEA(e.target.value)
                    );
                  }}
                  placeholder="00000/0000"
                />
                <FormErrorMessage>
                  {form.errors.numeroInclusao}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
      </Grid>
      <PromotoriaModal
        isOpen={isOpenPromotoria}
        onOpen={onOpenPromotoria}
        onClose={onClosePromotoria}
        selected={formProps.values.promotoriaId}
        setSelected={(value) => {
          formProps.setFieldValue("promotoriaId", value);
        }}
      />
      <VaraModal
        isOpen={isOpenVara}
        onOpen={onOpenVara}
        onClose={onCloseVara}
        selected={formProps.values.varaInfanciaId}
        setSelected={(value) => {
          formProps.setFieldValue("varaInfanciaId", value);
        }}
      />
    </Flex>
  );
};

export default Promotoria;
